import { FC } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { handleOpenDocument } from 'services/utils';
import Document from 'components/Document';

interface SupportingDocumentsProps {
  intl: IntlShape;
  info: any;
  listings: any;
  setCivilProceedingInfo: Function;
  stakeholders?: any;
  setIsUpdated?: Function;
  requestGetDocByDocumentumId: Function;
}
const SupportingDocuments: FC<SupportingDocumentsProps> = props => {
  const { documents } = props.info;
  return (
    <Grid container>
      <Grid
        container
        item
        direction="row"
        spacing={2}
        style={{ marginTop: 10 }}
      >
        {documents &&
          documents.map(
            (element: { name: string; type: string; url: string }) => (
              <Grid item xs={6}>
                <Document
                  name={element.name}
                  type={element.type}
                  icon={
                    <VisibilityIcon
                      className="consult"
                      onClick={handleOpenDocument(
                        element as any,
                        props.requestGetDocByDocumentumId,
                      )}
                    />
                  }
                />
              </Grid>
            ),
          )}
      </Grid>
    </Grid>
  );
};

export default injectIntl(SupportingDocuments);
